(function() {
  'use strict';

  // ==================== Yes/No Toggle ====================
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-addon-action]');
    if (!btn) return;

    const wrapper = btn.closest('[data-addon-wrapper]');
    if (!wrapper) return;

    const action = btn.dataset.addonAction;
    const statusInput = wrapper.querySelector('[data-addon-status]');
    const card = wrapper.querySelector('.addon-card');
    const progressFill = wrapper.querySelector('[data-addon-progress]');
    const yesBtn = wrapper.querySelector('.addon-btn-yes');
    const noBtn = wrapper.querySelector('.addon-btn-no');

    if (action === 'yes') {
      statusInput.value = '1';
      yesBtn.classList.add('active');
      noBtn.classList.remove('active');
      if (card) card.classList.add('is-selected');
      if (progressFill) progressFill.classList.add('filled');
    } else {
      statusInput.value = '0';
      yesBtn.classList.remove('active');
      noBtn.classList.add('active');
      if (card) card.classList.remove('is-selected');
      if (progressFill) progressFill.classList.remove('filled');
    }
  });

  // ==================== Helper: Get Selected Addons ====================
  function getSelectedAddons() {
    const addons = [];
    document.querySelectorAll('[data-addon-wrapper]').forEach(function(wrap) {
      const status = wrap.querySelector('[data-addon-status]');
      const variantId = wrap.querySelector('[data-addon-variant-id]');
      if (status && status.value === '1' && variantId && variantId.value) {
        addons.push({
          id: parseInt(variantId.value),
          quantity: 1
        });
      }
    });
    return addons;
  }

  // ==================== Intercept Normal Add to Cart ====================
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;

    const addonsToAdd = getSelectedAddons();
    if (addonsToAdd.length === 0) return;

    e.preventDefault();

    const formData = new FormData(form);
    const mainItem = {
      id: parseInt(formData.get('id')),
      quantity: parseInt(formData.get('quantity') || 1)
    };

    const properties = {};
    formData.forEach(function(val, key) {
      if (key.startsWith('properties[')) {
        const propKey = key.replace('properties[', '').replace(']', '');
        properties[propKey] = val;
      }
    });
    if (Object.keys(properties).length) mainItem.properties = properties;

    const items = [mainItem].concat(addonsToAdd);

    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
    .then(res => res.json())
    .then(data => {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      
      const drawerTrigger = document.querySelector('[data-cart-drawer-trigger], .js-drawer-open-cart, [href="/cart"]');
      if (window.theme && typeof window.theme.openCartDrawer === 'function') {
        window.theme.openCartDrawer();
      } else if (drawerTrigger) {
        drawerTrigger.click();
      } else {
        window.location.href = '/cart';
      }
    })
    .catch(err => {
      console.error('Addon cart error:', err);
      window.location.href = '/cart';
    })
    .finally(() => {
      if (submitBtn) submitBtn.disabled = false;
    });
  }, true);

  // ==================== Intercept Buy It Now / Dynamic Checkout ====================
  // Ye button Shopify ka custom element hai, isliye capture phase mein intercept karna padta hai
  document.addEventListener('click', function(e) {
    const buyNowBtn = e.target.closest(
      'shopify-buy-it-now-button button, ' +
      '.shopify-payment-button__button--unbranded, ' +
      '.shopify-payment-button__button, ' +
      '[data-testid="Checkout-button"]'
    );
    
    if (!buyNowBtn) return;

    const addonsToAdd = getSelectedAddons();
    if (addonsToAdd.length === 0) return; // No addons, let it proceed normally

    // Check if we already added addons (prevent infinite loop)
    if (buyNowBtn.dataset.addonProcessed === 'true') {
      buyNowBtn.dataset.addonProcessed = 'false';
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    // Find the product form
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    const formData = new FormData(form);
    const mainItem = {
      id: parseInt(formData.get('id')),
      quantity: parseInt(formData.get('quantity') || 1)
    };

    const properties = {};
    formData.forEach(function(val, key) {
      if (key.startsWith('properties[')) {
        const propKey = key.replace('properties[', '').replace(']', '');
        properties[propKey] = val;
      }
    });
    if (Object.keys(properties).length) mainItem.properties = properties;

    const items = [mainItem].concat(addonsToAdd);

    // Disable button & show loading
    buyNowBtn.disabled = true;
    const originalText = buyNowBtn.innerHTML;
    buyNowBtn.innerHTML = 'Processing...';

    // Add items to cart first, then redirect to checkout
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
    .then(res => res.json())
    .then(data => {
      // Redirect directly to checkout
      window.location.href = '/checkout';
    })
    .catch(err => {
      console.error('Buy Now addon error:', err);
      buyNowBtn.disabled = false;
      buyNowBtn.innerHTML = originalText;
      // Fallback - try cart page
      window.location.href = '/cart';
    });
  }, true); // true = capture phase (important!)

})();